import { JetView } from 'webix-jet';

/**
 * Class representing the details of a withdrawal request view.
 * @extends JetView
 */
export default class detailsWithdrawalRequestView extends JetView {
    /**
     * Configures the layout of the withdrawal request details view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        // Main information section configuration
        const main_info = {
            margin: 10,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    label: "<span class='icon-drivers-license-o'></span>" + _('Id'), // ID label with icon
                    labelPosition: 'top',
                    placeholder: _('Id'), // Placeholder for ID input
                    invalidMessage: _('A ID is required'), // Validation message
                    disabled: true, // Input is disabled
                },
                {
                    view: 'text',
                    name: 'Type',
                    label: _('Tipo'), // Type label
                    labelPosition: 'top',
                    placeholder: _('Tipo'), // Placeholder for Type input
                    disabled: true, // Input is disabled
                },
                {
                    view: 'text',
                    name: 'Date',
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Date label with icon
                    labelPosition: 'top',
                    placeholder: _('Fecha'), // Placeholder for Date input
                    disabled: true, // Input is disabled
                },
                {
                    view: 'text',
                    name: 'Amount',
                    label: _('Monto'), // Amount label
                    labelPosition: 'top',
                    placeholder: _('Monto'), // Placeholder for Amount input
                    disabled: true, // Input is disabled
                    id: 'Monto', // ID for Amount input
                },
            ],
        };

        // Second main information section configuration
        const second_main_info = {
            margin: 10,
            rows: [
                {
                    view: 'textarea',
                    name: 'PaymentSystemName',
                    label: _('Nombre sistema de pago'), // Payment system name label
                    labelPosition: 'top',
                    placeholder: _('Nombre sistema de pago'), // Placeholder for payment system name
                    disabled: true, // Input is disabled
                },
            ],
        };

        // Left main section configuration
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info], // Contains main_info
        };

        // Right main section configuration
        const rigth_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [second_main_info], // Contains second_main_info
        };

        // Upper section configuration with multiview
        const upper_section = {
            multiview: true,
            scroll: true,
            cols: [left_main, { gravity: 1, minWidth: 5 }, rigth_main], // Columns layout
        };

        // Narrow upper section configuration
        const upper_section_narrow = {
            padding: 10,
            rows: [main_info, second_main_info], // Stacked layout
        };

        // Window configuration for detailsCasino
        const detailsCasino = webix.ui({
            view: 'window',
            move: true,
            id: 'detailsCasino', // Window ID
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles Avanzados'), // Advanced details label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Close window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'dtDetails2', // Form ID
                type: 'clean',
                rows: [upper_section_narrow], // Contains narrow upper section
            },
        });

        // Main return structure for the view
        return {
            view: 'form',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? upper_section // Display upper section if screen size is adequate
                    : { height: 1, width: 0 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance to initialize.
     */
    init(form) {
        this.on(this.app, 'withdrawTransDetail:select', (person) => {
            // Event listener for selecting withdrawal transaction details
            if (screen.width > 500 && screen.height > 500) {
                form.setValues(person); // Set form values for larger screens
                this.$$('Monto').setValue(
                    webix.i18n.priceFormat(person.Amount), // Format and set amount value
                );
            } else {
                $$('dtDetails2').setValues(person); // Set values for smaller screens
            }
        });
    }
}

// FILE DOCUMENTED
